export enum ErrorType {
	REDIRECT = 'REDIRECT'
}